import { z } from 'zod';
export const newsletterSubscribeSchema = z.object({
    email: z.string().email().toLowerCase().trim(),
});
export const newsletterSubscriberSchema = z.object({
    id: z.string(),
    email: z.string().email(),
    confirmed: z.boolean(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=newsletter.js.map